import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { type SubdomainSession } from '@acl-services/jwt-highbond-middleware';
import { useSession } from './use-session';

const StyledBox = styled(Box)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SessionContext = createContext({} as SubdomainSession);

export function useSessionContext() {
  return useContext(SessionContext);
}

export function SessionProvider({ children }: PropsWithChildren) {
  const [shouldTolerateError, setShouldTolerateError] = useState(false);

  const { t } = useTranslation('common');

  const session = useSession();

  useEffect(() => {
    if (session.isError) {
      setShouldTolerateError(true);
    }
    if (session.isSuccess) {
      setShouldTolerateError(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.dataUpdatedAt]);

  if (!shouldTolerateError && session.isError) {
    return (
      <StyledBox>
        <div>{t('errors.initialUserAuthCheckError')}</div>
      </StyledBox>
    );
  }

  // It seems the JwtHighbondClient doesn't reject the Promise in case of a 401 response,
  // this why the code checks for the existence of the additional properties
  if (session.data && session.data.email && session.data.name) {
    return (
      <SessionContext.Provider value={session.data}>
        {children}
      </SessionContext.Provider>
    );
  }
}
